var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M3.223 18.1665C3.21 18.1665 3.198 18.1665 3.184 18.1655C2.869 18.1495 2.56 18.0815 2.266 17.9625C0.819002 17.3745 0.121002 15.7215 0.708002 14.2755L8.029 1.44951C8.281 0.993514 8.663 0.611514 9.129 0.353514C10.494 -0.402486 12.22 0.094514 12.975 1.45851L20.248 14.1865C20.41 14.5675 20.479 14.8775 20.496 15.1935C20.535 15.9495 20.277 16.6745 19.771 17.2355C19.265 17.7965 18.57 18.1275 17.815 18.1655L3.295 18.1665H3.223Z",
    fill: "#FFA502"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.625 7.01953C9.625 6.53753 10.018 6.14453 10.5 6.14453C10.982 6.14453 11.375 6.53753 11.375 7.01953V9.84753C11.375 10.3305 10.982 10.7225 10.5 10.7225C10.018 10.7225 9.625 10.3305 9.625 9.84753V7.01953ZM9.625 13.2686C9.625 12.7836 10.018 12.3886 10.5 12.3886C10.982 12.3886 11.375 12.7786 11.375 13.2576C11.375 13.7506 10.982 14.1436 10.5 14.1436C10.018 14.1436 9.625 13.7506 9.625 13.2686Z",
    fill: "#FFA502"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.8c4689e148cac12a7f49d938cb7bd292.svg";
export { ForwardRef as ReactComponent };